var PsrProfileSelectorModal = (function() {
    var cachedDOM = {};
    var MODALS = {};
    var modalState = {
        isOpen: false,
        stepList: [],
        activeStepIndex: 0
    };

    return {
        profileNotFoundError: function() {
            // TODO: improve error handlers
            alert("Perfil não encontrado");
            PsrProfileSelectorModal.closeAll();
        },

        openSelectProfileModal: function(data) {
            if (
                data.hasOwnProperty("productCode") ||
                data.hasOwnProperty("productStatus") ||
                data.hasOwnProperty("productType")
            ) {
                cachedDOM.$itemCartCode.val(data.itemCartCode || "");
                cachedDOM.$productCode.val(data.productCode || "");
                cachedDOM.$productStatus.val(data.productStatus || "");
                cachedDOM.$productType.val(data.productType || "");
            }

            cachedDOM.$profileIdSelect.empty();
            cachedDOM.$profileIdSelect.append(
                "<option value='' selected >Pessoa a ser analisada</option>"
            );

            $.ajax({
                type: "GET",
                url: "/apiV1/users/profile/list",
                crossDomain: false,
                data: {
                    userCode: cachedDOM.$userCode.val()
                },
                dataType: "json"
            }).done(function(profiles) {
                PsrProfileSelect.populateSelect(profiles, data.selectedProfile);
                PsrProfileSelectorModal.openModal(
                    MODALS["profile-select"].$DOM
                );
            });
        },

        openEditProfileModal: function() {
            var selectedProfileId = cachedDOM.$profileIdSelect.val();
            var userCode = cachedDOM.$userCode.val();

            PsrCityAutocomplete.setInputTarget({
                elementId: "psr-autocomplete"
            });
            PsrCityAutocomplete.openEditField();
            PsrCityAutocomplete.closeAutocompleteList();

            if (!selectedProfileId) {
                PsrLoader.stop();
                alert("Você deve selecionar um perfil");
                return;
            }

            $.ajax({
                type: "GET",
                url: "/apiV1/users/profile/retrieve",
                data: {
                    ProfileID: selectedProfileId,
                    userCode: userCode
                },
                dataType: "json"
            })
                .done(function(data) {
                    // TODO: improve error handlers
                    if (!Array.isArray(data)) {
                        return PsrProfileSelectorModal.profileNotFoundError();
                    }

                    data[0].selectedProfileId = selectedProfileId;

                    if (data[0].BirthTime === "X") {
                        data[0].dontKnowBirthTime = true;
                        PsrProfileSelectorForm.disableBirthTimeFields();
                    }

                    PsrProfileSelectorModal.feedbackTextHandler("edit");
                    PsrProfileSelectorModal.nicknameFieldHandler(
                        data[0].ProfileStatus
                    );
                    PsrProfileSelectorForm.fillEditFormFields(data[0]);

                    PsrProfileSelectorModal.setModalTitle("Editar perfil");
                    PsrProfileSelectorModal.openModal(MODALS.add.$DOM);

                    cachedDOM.$saveActionType.val("edit");
                })
                .fail(PsrProfileSelectorModal.profileNotFoundError);
        },

        openAddProfileModal: function() {
            PsrProfileSelectorModal.feedbackTextHandler("add");
            PsrProfileSelectorModal.nicknameFieldHandler();
            PsrProfileSelectorForm.cleanForm();
            PsrProfileSelectorModal.setModalTitle("Adicionar perfil");
            PsrProfileSelectorModal.openModal(MODALS.add.$DOM);

            PsrCityAutocomplete.setInputTarget({
                elementId: "psr-autocomplete"
            });
            PsrCityAutocomplete.removeReadonly();
            PsrCityAutocomplete.closeAutocompleteList();

            cachedDOM.$saveActionType.val("add");
        },

        openSummertimeModal: function(data) {
            var resolvedDate = PsrHelpers.summertimeDateResolver(
                data.birthDate,
                data.birthTime
            );

            cachedDOM.$userBirthTime.text(
                PsrHelpers.hhmmTimeFormat(resolvedDate.normaltime, "h")
            );
            cachedDOM.$userSummertimeBirthTime.text(
                PsrHelpers.hhmmTimeFormat(resolvedDate.summertime, "h")
            );

            PsrProfileSelectorModal.openModal(MODALS.summertime.$DOM);
        },

        openNumerologyModal: function(data) {
            $.ajax({
                type: "GET",
                url: "/apiV1/users/profile/retrieve",
                data: {
                    ProfileID: PsrProfileSelect.getSelectedProfileId(),
                    userCode: cachedDOM.$userCode.val()
                },
                dataType: "json"
            })
                .done(function(data) {
                    // Todo: Refactory at the profile retrieve API endpoint to get a better response
                    if (!data[0]) {
                        return PsrProfileSelectorModal.profileNotFoundError();
                    }

                    PsrProfileSelectorForm.fillNumerologyFormFields(data[0]);

                    PsrProfileSelectorModal.openModal(
                        MODALS["profile-numerology"].$DOM
                    );
                })
                .fail(PsrProfileSelectorModal.profileNotFoundError);
        },

        openNumerologyYearModal: function(data) {
            $.ajax({
                type: "GET",
                url: "/apiV1/users/profile/retrieve",
                data: {
                    ProfileID: PsrProfileSelect.getSelectedProfileId(),
                    userCode: cachedDOM.$userCode.val()
                },
                dataType: "json"
            })
                .done(function(data) {
                    // Todo: Refactory at profile retrieve API to get a better response
                    if (!data[0]) {
                        return PsrProfileSelectorModal.profileNotFoundError();
                    }

                    PsrProfileSelectorForm.fillNumerologyFormFields(data[0]);

                    PsrProfileSelectorModal.openModal(
                        MODALS["profile-numerology-year"].$DOM
                    );
                })
                .fail(PsrProfileSelectorModal.profileNotFoundError);
        },

        openNumerologyForecastModal: function (data) {
            $.ajax({
                type: 'GET',
                url: '/apiV1/users/profile/retrieve',
                data: {
                    ProfileID: PsrProfileSelect.getSelectedProfileId(),
                    userCode: cachedDOM.$userCode.val()
                },
                dataType: 'json'
            }).done(function (data) {
                // Todo: Refactory at profile retrieve API to get a better response
                if (!data[0]) {
                    return PsrProfileSelectorModal.profileNotFoundError();
                }

                PsrProfileSelectorForm.fillNumerologyForecastFormFields(data[0]);

                PsrProfileSelectorModal.openModal(MODALS['profile-numerology-forecast'].$DOM);
            }).fail(PsrProfileSelectorModal.profileNotFoundError);
        },

        openSolarRevolutionModal: function() {
            var selectedProfileID = PsrProfileSelect.getSelectedProfileId();

            $.ajax({
                type: "GET",
                url: "/apiV1/users/profile/retrieve",
                data: {
                    ProfileID: selectedProfileID,
                    userCode: cachedDOM.$userCode.val()
                },
                dataType: "json"
            })
                .done(function(data) {
                    // Todo: Refactory at profile retrieve API to get a better response
                    if (!data[0]) {
                        return PsrProfileSelectorModal.profileNotFoundError();
                    }

                    PsrProfileSelectorForm.fillSolarRevolutionFormFields(
                        data[0]
                    );

                    PsrProfileSelectorModal.openModal(
                        MODALS["profile-solar-revolution"].$DOM
                    );
                })
                .fail(PsrProfileSelectorModal.profileNotFoundError);
        },

        openFeedbackSuccessModal: function() {
            PsrProfileSelectorModal.openModal(MODALS.feedbackSuccess.$DOM);
        },

        closeAll: function() {
            cachedDOM.$modals.removeClass("is-active");

            PsrProfileSelectorModal.allowBodyScroll();
            PsrLoader.stop();
        },

        allowBodyScroll: function() {
            document.body.classList.remove("psr-modal--open");
        },

        blockBodyScroll: function() {
            document.body.classList.add("psr-modal--open");
        },

        restoreLastScrollPosition: function() {
            if (modalState.isOpen) {
                window.scrollTo(0, modalState.userScrollPosition);
                modalState.isOpen = false;
            }
        },

        saveCurrentScrollPosition: function() {
            if (!modalState.isOpen) {
                modalState.isOpen = true;
                modalState.userScrollPosition = $(window).scrollTop();
            }
        },

        openModal: function($modal) {
            PsrProfileSelectorModal.closeAll();
            PsrProfileSelectorModal.blockBodyScroll();

            $modal.addClass("is-active");

            if (window.innerWidth <= 768) {
                window.scrollTo(0, 0);
            }
        },

        nicknameFieldHandler: function(profileStatus) {
            if (profileStatus == "1") {
                cachedDOM.$nicknameField.show();
            } else {
                cachedDOM.$nicknameField.hide();
            }
        },

        feedbackTextHandler: function(type) {
            if (type === "add") {
                cachedDOM.$feedbackText.text("Perfil adicionado com sucesso");
            } else {
                cachedDOM.$feedbackText.text("Perfil editado com sucesso");
            }
        },

        redirectToLogin: function() {
            var locationSearch = window.location.search || "?";
            var locationPathname = window.location.pathname;
            var returnUrl = locationPathname + locationSearch + "&openPop=pop";

            return (window.location.href =
                "/login?ReturnToURL=" + window.btoa(returnUrl));
        },

        openAction: function(modalType, data) {
            var modalType = modalType || "close";
            var data = data || {};

            PsrProfileSelectorModal.saveCurrentScrollPosition();
            PsrLoader.start();

            if (!cachedDOM.$userCode.val()) {
                return PsrProfileSelectorModal.redirectToLogin();
            }

            MODALS[modalType].action(data);
        },

        setModalTitle: function(title) {
            MODALS.add.$DOM.find(".psr-modal__header .psr-title").text(title);
        },

        next: function() {
            var stepLength = modalState.stepList.length;
            var nextStepIndex = modalState.activeStepIndex + 1;

            if (nextStepIndex <= stepLength - 1) {
                modalState.activeStepIndex = nextStepIndex;

                return PsrProfileSelectorModal.openAction(
                    modalState.stepList[nextStepIndex]
                );
            }

            return GenericProductHandler.generate();
        },

        launch: function(actionType, data) {
            if (actionType === "add" || actionType === "edit") {
                return PsrProfileSelectorModal.openAction(actionType);
            }

            modalState.activeStepIndex = 0;

            PsrProfileSelectorModal.openAction(modalState.stepList[0], data);
        },

        init: function() {
            MODALS = {
                "profile-select": {
                    $DOM: $("[data-name='profile-select']"),
                    action: PsrProfileSelectorModal.openSelectProfileModal
                },
                add: {
                    $DOM: $("[data-name='profile-add']"),
                    action: PsrProfileSelectorModal.openAddProfileModal
                },
                edit: {
                    $DOM: $("[data-name='profile-add']"),
                    action: PsrProfileSelectorModal.openEditProfileModal
                },
                summertime: {
                    $DOM: $("[data-name='profile-summertime']"),
                    action: PsrProfileSelectorModal.openSummertimeModal
                },
                "profile-numerology-year": {
                    $DOM: $("[data-name='profile-numerology-year']"),
                    action: PsrProfileSelectorModal.openNumerologyYearModal
                },
                "profile-numerology": {
                    $DOM: $("[data-name='profile-numerology']"),
                    action: PsrProfileSelectorModal.openNumerologyModal
                },
                'profile-numerology-forecast': {
                    $DOM: $("[data-name='profile-numerology-forecast']"),
                    action: PsrProfileSelectorModal.openNumerologyForecastModal
                },
                "profile-solar-revolution": {
                    $DOM: $("[data-name='profile-solar-revolution']"),
                    action: PsrProfileSelectorModal.openSolarRevolutionModal
                },
                close: {
                    action: PsrProfileSelectorModal.closeAll
                },
                feedbackSuccess: {
                    $DOM: $("[data-name='profile-feedback-success']"),
                    action: PsrProfileSelectorModal.openFeedbackSuccessModal
                }
            };

            cachedDOM.userScrollPosition = null;
            cachedDOM.$userBirthTime = $("#userBirthTime");
            cachedDOM.$userSummertimeBirthTime = $("#userSummertimeBirthTime");
            cachedDOM.$userProfileName = $("#userProfileName");
            cachedDOM.$profileIdSelect = $("[name='profileID']");
            cachedDOM.$userCode = $("[name='userCode']");
            cachedDOM.$profileIdSelected = $("[name='selectedProfileId']");
            cachedDOM.$itemCartCode = $("[name='itemCartCode']");
            cachedDOM.$productCode = $("[name='productCode']");
            cachedDOM.$productStatus = $("[name='productStatus']");
            cachedDOM.$productType = $("[name='productType']");
            cachedDOM.$saveActionType = $("[name='saveActionType']");

            cachedDOM.$saveProfileForm = $("[data-action-type='save-profile']");
            cachedDOM.$confirmNumerologyForm = $("[data-action-type='confirm-numerology']");
            cachedDOM.$confirmNumerologyForecastForm = $("[data-action-type='confirm-numerology-forecast']");
            cachedDOM.$confirmSolarRevolutionForm = $("[data-action-type='confirm-solar-revolution']");

            cachedDOM.$nicknameField = $("#nickname-field");
            cachedDOM.$feedbackText = $("#form-profile-feedback__text");

            cachedDOM.$modals = $(".psr-modal");

            modalState.stepList = GenericProductHandler.getCurrentProductSteps();
        }
    };
})();
